module.exports = __webpack_public_path__ + "static/img/hyundai-transys-renewal2025.8f04abf.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/hyundai-transys-renewal2025.jpg
// module id = oVsL
// module chunks = 0